/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { ReactComponent as CalendarIcon } from "../../../../img/approval_svgs/permit/Calendar.svg";
import { ReactComponent as NoFeeIcon } from "../../../../img/approval_svgs/permit/NoFees.svg";
import { ReactComponent as SecurityIcon } from "../../../../img/approval_svgs/permit/Security.svg";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Theme } from "../../../../styles/theme";
import { withIsVisible } from "../../../../utils/reactUtils";
import { Text } from "../../../general/Text";

const ApprovalsBenefitsSection: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const content = () => {
    return (
      <div
        css={css`
          display: flex;
          gap: 50px;
        `}
      >
        <CentralDivWrapper>
          <SecurityIcon />
          <Text
            textStyle="Paragraph"
            size="Medium"
            shouldScale={false}
            textCss={css`
              margin-top: 5px;
            `}
          >
            Industry standard <br /> & secure
          </Text>
        </CentralDivWrapper>
        <CentralDivWrapper>
          <CalendarIcon />
          <Text
            textStyle="Paragraph"
            size="Medium"
            shouldScale={false}
            textCss={css`
              margin-top: 5px;
            `}
          >
            Token access lasts <br /> for 30 days
          </Text>
        </CentralDivWrapper>
        <CentralDivWrapper>
          <NoFeeIcon />
          <Text
            textStyle="Paragraph"
            size="Medium"
            shouldScale={false}
            textCss={css`
              margin-top: 5px;
            `}
          >
            Free with no <br /> network fees
          </Text>
        </CentralDivWrapper>
      </div>
    );
  };

  return <Permit2SectionWrapper theme={theme}>{content()}</Permit2SectionWrapper>;
};

const Permit2SectionWrapper = styled.div<{ theme: Theme }>`
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 60px;
  height: 94px;
  background-color: ${props => props.theme.surface.main.secondary.default};
`;

const CentralDivWrapper = styled.div`
  text-align: center;
  width: 103px;
`;

export default withIsVisible(ApprovalsBenefitsSection);
